import React from 'react';
import { Container, Typography, Box } from '@mui/material';
import { theme } from '../styles/theme';

const Home = () => {
  return (
    <Box sx={{ 
      minHeight: '100vh', 
      bgcolor: theme.palette.background.default,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography variant="h2" component="h1" sx={{ color: theme.palette.primary.main }}>
            Welcome to Yogi Plus Water Tank
          </Typography>
          <Typography variant="h5" sx={{ mt: 4, color: theme.palette.secondary.main }}>
            Your trusted partner for quality water storage solutions
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Home;